import { render, staticRenderFns } from "./VeJwCjfx.vue?vue&type=template&id=53f96eda"
import script from "./VeJwCjfx.vue?vue&type=script&lang=js"
export * from "./VeJwCjfx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports